import { cn } from "@/lib/utils";

interface OnboardingTileProps {
  icon: React.ReactNode;
  label: string;
  subtitle?: string;
  selected: boolean;
  onClick: () => void;
}

export function OnboardingTile({
  icon,
  label,
  subtitle,
  selected,
  onClick,
}: OnboardingTileProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "flex w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border p-4 text-center transition-all",
        selected
          ? "border-brand bg-brand/5 ring-1 ring-brand/30"
          : "border-border bg-background hover:border-foreground/30",
      )}
    >
      <span className="text-3xl">{icon}</span>
      <span className="text-sm font-medium text-foreground">{label}</span>
      {subtitle && (
        <span className="text-xs text-muted-foreground">{subtitle}</span>
      )}
    </button>
  );
}
